"use strict"

const validMessage = {
    required:"Trường này là bắt buộc",
    email:"Sai định dạng email",
    phone:"Sai định dạng số điện thoại",
    min:function (length) {
        return `Độ dài tối thiểu ${length} ký tự`
    },
    max:function (length) {
        return `Độ dài tối đa ${length} ký tự`
    },
}

export default validMessage